import React, { FC, SVGProps } from "react";

export const IconUser: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M6.99992 0.333008C7.88397 0.333008 8.73182 0.684197 9.35694 1.30932C9.98206 1.93444 10.3333 2.78229 10.3333 3.66634C10.3333 4.5504 9.98206 5.39824 9.35694 6.02336C8.73182 6.64849 7.88397 6.99967 6.99992 6.99967C6.11586 6.99967 5.26802 6.64849 4.6429 6.02336C4.01777 5.39824 3.66659 4.5504 3.66659 3.66634C3.66659 2.78229 4.01777 1.93444 4.6429 1.30932C5.26802 0.684197 6.11586 0.333008 6.99992 0.333008ZM6.99992 8.66634C10.6833 8.66634 13.6666 10.158 13.6666 11.9997V13.6663H0.333252V11.9997C0.333252 10.158 3.31659 8.66634 6.99992 8.66634Z"
        fill="currentColor"
      />
    </svg>
  );
};
